import { Campaign, CampaignTypes } from '@/models/reward';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardExtrasCampaignCard',
})
export default class CmgRewardExtrasCampaignCard extends Vue {
  @Prop({ required: true, type: Object })
  campaign!: Campaign;

  get progressPercentage(): number {
    return this.campaign.isMultiStepCampaign
      ? (this.campaign.currentStep / this.campaign.totalNumberOfSteps) * 100
      : 0;
  }

  get expirationDate(): string {
    if (this.campaign.endDate) {
      return new Date(this.campaign.endDate).toLocaleDateString();
    }
  
    return '';
  }

  get isExtra(): boolean {
    return !this.campaign.isMultiStepCampaign;
  }

  get extraPoints(): number {
    return this.campaign.extraPoints;
  }

  get medallionBackgroundUrl(): string {
    if (this.campaign.medallionText) {
      return this.$appStore.state.cms.images.backgrounds.pointsMultiplier.default;
    } else {
      return this.$appStore.state.cms.images.backgrounds.pointsEarned.default;
    }
  }

  onClickCampaignCard() {
    const campaign = this.campaign;
    this.$services.ui.setModalVisibility('rewardExtrasCampaignDetail', true, { campaign });
  }
}